import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";

function FleetPhoto({ src, alt, caption, testid }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);

  return (
    <div
      ref={ref}
      data-testid={testid}
      className="clip-frame group relative h-[340px] w-full overflow-hidden border border-white/12 bg-panel sm:h-[480px] lg:h-[560px]"
    >
      <motion.img
        src={src}
        alt={alt}
        style={{ y }}
        className="h-full w-full scale-[1.18] object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-ink/10" />
      <span className="absolute right-5 top-5 h-8 w-8 border-r-2 border-t-2 border-cobalt" />
      <div className="absolute bottom-5 left-5 border border-white/20 bg-ink/60 px-3 py-1.5 font-mono text-[10px] tracking-[0.3em] text-white/80 backdrop-blur">
        {caption}
      </div>
    </div>
  );
}

export default function Fleet() {
  return (
    <section id="fleet" className="scroll-mt-24 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-8">
          <div>
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-cobalt">
                The fleet
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display text-[clamp(2.5rem,6vw,5rem)] font-extrabold uppercase leading-[0.92]">
                Our trucks,
                <br />
                our hands on the wheel.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-base leading-relaxed text-white/60">
              You always know whose truck is carrying your freight — our own
              equipment, run out of Omaha, Nebraska.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <FleetPhoto
              src="/trucks/white-truck.jpg"
              alt="ZAKI Logistics white tractor, unit 570, coupled to a Carrier reefer trailer"
              caption="UNIT 570 · REEFER EQUIPMENT"
              testid="fleet-photo-white"
            />
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <FleetPhoto
              src="/trucks/blue-truck.jpg"
              alt="ZAKI Logistics blue tractor, unit 572, parked in Omaha NE"
              caption="UNIT 572 · OMAHA, NE"
              testid="fleet-photo-blue"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
